import { FileEntity } from '@/hooks/upload-files/types';
import { fetch } from '@/shared/fetch';

export const sendDoctorFile = async (fileEntity: FileEntity) => {
    const formData = new FormData();
    formData.append('file', fileEntity.file);
    return await fetch<string>(
        '/api/files/doctor-upload',
        'POST',
        formData,
        'AUTOMATIC',
    );
};

export const sendPatientFile = async (fileEntity: FileEntity) => {
    const formData = new FormData();
    formData.append('file', fileEntity.file);
    return await fetch<string>(
        '/api/files/upload',
        'POST',
        formData,
        'AUTOMATIC',
    );
};
